import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useEntryPointStore } from "@/stores/entryPointStore";
import ActivityItem from "components/ActivityBar/ActivityItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InteractiveItem',
    props: {
        id: null,
        title: null,
        icon: null,
        isActive: { type: Boolean },
        to: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const { entryPoints } = storeToRefs(useEntryPointStore());
        const totalCount = computed(() => entryPoints.value.length);
        const tooltip = computed(() => totalCount.value === 1
            ? `You currently have 1 active interactive tool`
            : `You currently have ${totalCount.value} active interactive tools`);
        return { __sfc: true, entryPoints, totalCount, emit, tooltip, ActivityItem };
    }
});
